// components/Hero.js
function Hero() {
    return (
        <section>
            {/* Putter hero content her hvis jeg har tid */}
        </section>
    );
}

export default Hero;